import React, { Component } from "react";
import Aux from "../../../../hoc/Auxilliary";
import {
  getJobRoleGroups,
  createJobRoleGroup,
  updateJobRoleGroup,
  deleteJobRoleGroup
} from "../../../../data-service-admin";
import { ToastContainer } from "react-toastr";
import DeleteModal from "../Common/DeleteModal";
import AddEditModal from "../Common/AddEditModal";
import { showSuccessToastMessage, showErrorToastMessage } from "../../../../utilities";
import Grid from "../Common/Grid";
import Spinner from "../../../User/Common/Spinner/Spinner";
import Search from "../Common/Search";
import AdminBreadcrumb from "../Common/Breadcrumb";
import { emptyCheck } from "../../../../utilities";
import RequiredField from "../Common/RequiredField";

class AdminJobRoleGroups extends Component {
  state = {
    masterjobrolegroups: [],
    jobrolegroups: [],
    selectedJobRoleGroup: {},
    showModal: false,
    modalTitle: "",
    showDeleteModal: false,
    modalDeleteTitle: "",
    modalDeleteMessage: "",
    action: "edit",
    showSpinner: false,
    searchTerm: "",
    errorMessage: ""
  };
  componentDidMount() {
    this.getJobRoleGroupsFromService();
  }
  showSpinner(isShow) {
    this.setState({
      showSpinner: isShow
    });
  }
  getJobRoleGroupsFromService() {
    this.showSpinner(true);
    getJobRoleGroups()
      .then(response => {
        this.setState({ jobrolegroups: response.data, masterjobrolegroups: response.data });
        this.showSpinner(false);
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error);
        this.showErrorMessage(error);
      });
  }

  editJobRoleGroup(jobrolegroup) {
    this.setState({
      action: "edit",
      selectedJobRoleGroup: jobrolegroup,
      showModal: true,
      errorMessage: ""
    });
  }

  deleteJobRoleGroup(jobrolegroup) {
    this.setState({
      action: "delete",
      selectedJobRoleGroup: jobrolegroup,
      showDeleteModal: true
    });
  }

  addJobRoleGroup() {
    this.setState({
      action: "add",
      selectedJobRoleGroup: {},
      showModal: true,
      errorMessage: ""
    });
  }
  onHideModal() {
    this.setState({
      showModal: false
    });
  }

  onHideDeleteModal() {
    this.setState({
      showDeleteModal: false
    });
  }
  showSuccessMessage(item) {
    showSuccessToastMessage(this, "toastr1", this.state.action, item, "JobRoleGroup");
  }
  showErrorMessage(error) {
    showErrorToastMessage(this, "toastr1", error);
  }
  validate(data) {
    if (emptyCheck(data.Name)) {
      this.setState({ errorMessage: "Name cannot be blank" });
      return false;
    }
    return true;
  }
  saveJobRoleGroup() {
    const data = {
      Id: this.state.action === "edit" ? this.state.selectedJobRoleGroup.Id : 0,
      Name: this.refs["txtJobRoleGroup"].value
    };
    if (this.validate(data)) {
      switch (this.state.action) {
        case "add":
          this.showSpinner(true);
          createJobRoleGroup(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getJobRoleGroupsFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        case "edit":
          this.showSpinner(true);
          updateJobRoleGroup(data)
            .then(response => {
              this.showSpinner(false);
              console.log(response);
              this.onHideModal();
              this.showSuccessMessage(data.Name);
              this.getJobRoleGroupsFromService();
            })
            .catch(error => {
              this.showSpinner(false);
              console.log(error);
              this.showErrorMessage(error);
              this.onHideModal();
            });
          break;
        default:
          break;
      }
    }
  }
  confirmDeleteJobRoleGroup() {
    this.showSpinner(true);
    deleteJobRoleGroup(this.state.selectedJobRoleGroup.Id)
      .then(response => {
        this.showSpinner(false);
        console.log(response);
        this.onHideDeleteModal();
        this.showSuccessMessage(this.state.selectedJobRoleGroup.Name);
        this.getJobRoleGroupsFromService();
      })
      .catch(error => {
        this.showSpinner(false);
        console.log(error.response);
        this.showErrorMessage(error);
        this.onHideDeleteModal();
      });
  }
  handleJobRoleGroupChange = event => {
    let selectedJobRoleGroup = this.state.selectedJobRoleGroup;
    selectedJobRoleGroup.Name = event.target.value;
    this.setState({ selectedJobRoleGroup: selectedJobRoleGroup });
  };

  manageJobRoles(jobrolegroup) {
    this.props.history.push(`/admin/jobroles/` + jobrolegroup.Id);
  }

  handleSearchTermChange = event => {
    let filteredJobRoleGroups = this.state.masterjobrolegroups.filter(d => {
      const name = String(d.Name).toLowerCase();
      return name.indexOf(event.target.value) > -1;
    });
    if (event.target.value)
      this.setState({
        jobrolegroups: filteredJobRoleGroups,
        searchTerm: event.target.value
      });
    else
      this.setState({
        jobrolegroups: this.state.masterjobrolegroups,
        searchTerm: event.target.value
      });
  };

  render() {
    return (
      <Aux>
        <ToastContainer ref="toastr1" className="toast-top-right" />
        <Spinner showSpinner={this.state.showSpinner} />
        <h1 className="page-header">Job Role Groups</h1>
        <AdminBreadcrumb data={[{ name: "Home", link: "/admin/modules/" }, { name: "Job Role Groups" }]} />
        <button className="btn btn-default add-btn" onClick={() => this.addJobRoleGroup()}>
          Add Job Role Group
        </button>
        <Search searchTerm={this.state.searchTerm} handleSearchTermChange={this.handleSearchTermChange.bind(this)} />
        <Grid
          headers={["#", "Name"]}
          values={this.state.jobrolegroups}
          indexName="Id"
          properties={["Id", "Name", "Action"]}
          edit={value => this.editJobRoleGroup(value)}
          delete={value => this.deleteJobRoleGroup(value)}
          extraActions={[value => this.manageJobRoles(value)]}
          extraActionNames={["Manage Job Roles"]}
        />
        <AddEditModal
          showModal={this.state.showModal}
          onHideModal={() => this.onHideModal()}
          modalTitle={this.state.modalTitle}
          save={() => this.saveJobRoleGroup()}
          form={this.addeditform}
          type="Job Role Group"
          action={this.state.action}
          errorMessage={this.state.errorMessage}
        >
          <div className="form-group">
            <label>
              <RequiredField />Name:
            </label>
            <input
              maxLength="50"
              type="text"
              className="form-control"
              ref="txtJobRoleGroup"
              defaultValue={this.state.selectedJobRoleGroup.Name}
            />
          </div>
        </AddEditModal>
        <DeleteModal
          key={this.state.selectedJobRoleGroup.Id}
          showModal={this.state.showDeleteModal}
          onHideModal={() => this.onHideDeleteModal()}
          confirm={() => this.confirmDeleteJobRoleGroup()}
          name={this.state.selectedJobRoleGroup.Name}
          type="Job Role Group"
        />
      </Aux>
    );
  }
}

export default AdminJobRoleGroups;



// WEBPACK FOOTER //
// ./src/containers/Admin/AdminMainContent/JobRoleGroups/JobRoleGroups.js